export const paths = {
  home: '/',
  'age-calculator': '/age-calculator',
  'age-difference': '/age-difference',
  'days-left': '/days-left',
  'planets-age': '/planets-age',
  'next-birthday': '/next-birthday',
  'days-you-lived': '/days-you-lived',
  'zodiac-sign': '/zodiac-sign',
  'week-day': '/week-day',
  'days-difference': '/days-difference',
  'contact-us': '/contact-us',
  'about-us': '/about-us',
};
